import { Theme } from '@mui/material/styles'

export function injectThemeCSSVariables(
  theme: Theme,
  mode: 'light' | 'dark' = 'light',
) {
  // console.log('mode', { mode })
  const root = document.documentElement

  // Function để flatten nested object thành CSS custom properties
  const flattenObject = (
    obj: any,
    prefix = '',
    maxDepth = 5,
    depth = 0,
  ): Record<string, string> => {
    const result: Record<string, string> = {}

    // Ngăn chặn infinite loop
    if (depth > maxDepth) {
      return result
    }

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key]
        const newKey = prefix ? `${prefix}-${key}` : `--${key}`
        const kebabKey = newKey //toKebabCase(newKey)

        if (typeof value === 'string') {
          // Chỉ lưu giá trị string (màu sắc)
          result[kebabKey] = value
        } else if (
          typeof value === 'object' &&
          value !== null &&
          !Array.isArray(value)
        ) {
          Object.assign(
            result,
            flattenObject(value, newKey, maxDepth, depth + 1),
          )
        } else if (typeof value === 'number') {
          result[kebabKey] = `${value}`
        }
      }
    }

    return result
  }

  // Convert camelCase/PascalCase thành kebab-case
  const toKebabCase = (str: string): string => {
    return str
      .replace(/([a-z])([A-Z])/g, '$1-$2') // camelCase
      .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2') // PascalCase
      .toLowerCase()
  }

  // Flatten toàn bộ palette object
  const cssVars = flattenObject(theme.palette, '', 5, 0)

  // Thêm breakpoints
  if (theme.breakpoints) {
    Object.entries(theme.breakpoints.values).forEach(([key, value]) => {
      cssVars[`--breakpoint-${key.toLowerCase()}`] = `${value}px`
    })
  }

  // Apply tất cả CSS variables vào document
  // Object.entries(cssVars).forEach(([key, value]) => {
  //   root.style.setProperty(key, value)
  // })

  // Tạo CSS string với selector phù hợp
  let cssText = `[data-theme="${mode}"] {\n`
  Object.entries(cssVars).forEach(([key, value]) => {
    cssText += `  ${key}: ${value};\n`
  })
  cssText += '}'

  // Tìm hoặc tạo <style> tag với ID theo theme
  const styleId = `theme-css-variables-${mode}`
  let styleTag = document.getElementById(styleId) as HTMLStyleElement | null

  if (!styleTag) {
    styleTag = document.createElement('style')
    styleTag.id = styleId
    document.head.appendChild(styleTag)
  }

  // Inject CSS vào style tag
  styleTag.textContent = cssText

  return cssVars
}
